
export default {
    spacingDebug: true,
    props: {
        items: { type: Array, default: () => [] },
        activeIndex: { type: Number, default: 0 },
        interval: { type: Number, default: 5000 },
        autoplayPaused: { type: Boolean, default: false },
        position: { type: String, default: "bottom" },
        theme: { type: String, default: "dark" },
        ariaLabel: { type: String, default: "Carousel slides" },
        showLabel: { type: Boolean, default: true },
        paginationClass: { type: [String, Array, Object], default: "" },
        dotClass: { type: [String, Array, Object], default: "" },
        activeClass: { type: String, default: "" },
        fillWrapperClass: { type: [String, Array, Object], default: "" },
        fillClass: { type: [String, Array, Object], default: "" },
    },
    data: () => ({
        timer: null,
        isInteractionPaused: false,
    }),
    computed: {
        hasPagination() {
            return this.items.length > 1;
        },
        canAutoplay() {
            return this.interval > 0 && this.hasPagination;
        },
        isAutoplaying() {
            const isDocumentHidden = typeof document !== "undefined" && document.hidden;
            return this.canAutoplay && !this.autoplayPaused && !this.isInteractionPaused && !isDocumentHidden;
        },
        paginationStyle() {
            return { "--carousel-duration": `${this.interval}ms`, "--carousel-label-space": this.showLabel ? "2.15rem" : "0" };
        },
    },
    watch: {
        items() {
            this.restartTimer();
        },
        interval() {
            this.restartTimer();
        },
        autoplayPaused() {
            this.restartTimer();
        },
    },
    methods: {
        getItemLabel(item, index) {
            const title = typeof item?.title === "string" ? item.title.replace(/<[^>]*>/g, "").trim() : "";
            const name = typeof item?.name === "string" ? item.name.trim() : typeof item?.alt === "string" ? item.alt.trim() : "";
            return name || title || `item ${index + 1}`;
        },
        select(index) {
            this.$emit("select", index);
            this.restartTimer();
        },
        next() {
            this.select((this.activeIndex + 1) % this.items.length);
        },
        startTimer() {
            if (!this.isAutoplaying) return;
            this.stopTimer();
            this.timer = setInterval(this.next, this.interval);
        },
        stopTimer() {
            clearInterval(this.timer);
            this.timer = null;
        },
        restartTimer() {
            this.stopTimer();
            this.startTimer();
        },
        pauseTimer() {
            this.isInteractionPaused = true;
            this.stopTimer();
        },
        resumeTimer(event) {
            const container = event?.currentTarget;
            if (container) {
                this.$nextTick(() => {
                    if (container.contains(document.activeElement)) return;
                    this.isInteractionPaused = false;
                    this.startTimer();
                });
                return;
            }

            this.isInteractionPaused = false;
            this.startTimer();
        },
        handleVisibilityChange() {
            this.restartTimer();
        },
    },
    mounted() {
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        this.startTimer();
    },
    beforeDestroy() {
        this.stopTimer();
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    },
};
